"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesHttpAdapter = void 0;
var Utility_1 = require("./Utility");
var uuid_1 = require("uuid");
var Types_1 = require("./Types");
var HttpAdapter_1 = require("./HttpAdapter");
var Registry_1 = require("./Registry");
var GamesHttpAdapter = /** @class */ (function (_super) {
    __extends(GamesHttpAdapter, _super);
    function GamesHttpAdapter(options) {
        return _super.call(this, options) || this;
    }
    GamesHttpAdapter.prototype.getEndpoint = function () {
        if (this.options.platformName === Registry_1.registry.platforms.seven.name) {
            switch (this.options.environment) {
                case 'production':
                    // Not all platform DCc have direct own NGS route
                    var directRoutes = {
                        default: 'https://games.gb.nsoftcdn.com',
                        rs: 'https://games.gb.nsoftcdn.com',
                        rs2: 'https://games.gb.nsoftcdn.com',
                        ro: 'https://games.ro.nsoftcdn.com',
                        ro2: 'https://games.ro.nsoftcdn.com',
                        de: 'https://games.de.nsoftcdn.com',
                    };
                    var platformDataCenter = this.options.platformDataCenter || 'default';
                    return directRoutes[platformDataCenter] || directRoutes.default;
                case 'staging':
                    return 'https://games.staging.gb.nsoftcdn.com';
                default:
                    return 'https://ngs-dev.7platform.com/app_dev.php';
            }
        }
        else {
            switch (this.options.environment) {
                case 'production':
                    return 'https://games.gb.nsoftcdn.com';
                case 'staging':
                    return 'https://games-playtech.staging.gb.nsoftcdn.com';
                default:
                    return 'https://ngs-dev.7platform.com';
            }
        }
    };
    GamesHttpAdapter.prototype.getIntegrationEndpoint = function () {
        return "https://ngs-".concat(this.options.platformName, "-integration.nsoft.com");
    };
    GamesHttpAdapter.prototype.getTranslationsEndpoint = function () {
        if (this.options.environment === 'staging') {
            return 'https://frasier.staging.de-2.nsoft.cloud/translations';
        }
        return 'https://frasier.de-2.nsoft.cloud/translations';
    };
    GamesHttpAdapter.prototype.getEndpointPath = function () {
        var isSevenPlatform = this.options.platformName === Registry_1.registry.platforms.seven.name;
        if (isSevenPlatform && (this.options.translationsFromFrasier || !this.options.translationDomains)) {
            return "/api_open/config/".concat(this.options.productId);
        }
        else if (isSevenPlatform && !this.options.translationsFromFrasier && this.options.translationDomains) {
            return "/api_open/config/".concat(this.options.productId, "?domain=").concat(this.options.translationDomains, "&translationsMerge=true");
        }
        else {
            return "/".concat(this.options.platformName, "/config?domain=").concat(this.options.translationDomains, "&translationsMerge=true");
        }
    };
    GamesHttpAdapter.prototype.getLoginEndpointPath = function () {
        return "/".concat(this.options.platformName, "/player/login");
    };
    GamesHttpAdapter.prototype.getLoginTokenEndpointPath = function () {
        return "/".concat(this.options.platformName, "/player/get-token");
    };
    GamesHttpAdapter.prototype.getTranslationsEndpointPath = function (domain) {
        if (this.options.translationsFromFrasier) {
            var domainId = Registry_1.registry.translationDomainsMapping[domain];
            var locale = this.options.locale && this.options.locale.split(/[-_]/)[0] || 'en';
            return "/".concat(domainId, "/locales/").concat(locale, "/tenants/").concat(this.options.tenantId, "?includeLocaleFallback=true");
        }
        return "/".concat(domain, "/languages/").concat(this.options.locale, "/clients/").concat(this.options.tenantId);
    };
    GamesHttpAdapter.prototype.getEndpointHeaders = function () {
        var platformHeaders = {};
        return __assign({ 'Accept-Language': this.options.locale, 'X-Request-ID': (0, uuid_1.v4)(), 'X-Nsft-Ngs-Company': this.options.tenantId, 'X-Nsft-Ngs-Product': this.options.productId, 'SEVEN-LOCALE': this.options.locale }, platformHeaders);
    };
    GamesHttpAdapter.prototype.getEndpointParams = function () {
        if (this.options.platformName !== Registry_1.registry.platforms.seven.name) {
            return {
                cpvUuid: this.options.productId,
            };
        }
        else {
            return {
                channel: this.options.applicationName,
            };
        }
    };
    GamesHttpAdapter.prototype.getLoginEndpointParams = function () {
        if (this.options.platformName === Registry_1.registry.platforms.playtech.name) {
            var platformConfig = this.options.platformConfig;
            return {
                localeCode: this.options.locale,
                gameId: platformConfig.gameCode,
                secureToken: platformConfig.tempToken,
                accountId: platformConfig.accountId || '',
                skinId: platformConfig.casino,
                playerId: platformConfig.playerId,
                channelType: this.options.applicationName,
                _meta: {
                    gsId: platformConfig.gsId,
                    gpId: platformConfig.gpId,
                    requestId: (0, uuid_1.v4)(),
                    clientPlatform: platformConfig.clientPlatform,
                    clientType: platformConfig.clientType,
                },
            };
        }
    };
    GamesHttpAdapter.prototype.getLoginTokenEndpointParams = function () {
        if (this.options.platformName === Registry_1.registry.platforms.playtech.name) {
            var platformConfig = this.options.platformConfig;
            return {
                skinId: platformConfig.tenantId,
                playerId: platformConfig.playerId,
                password: platformConfig.password,
                language: this.options.locale,
                gameId: platformConfig.gameCode,
                _meta: {
                    gsId: platformConfig.gsId,
                    gpId: platformConfig.gpId,
                    requestId: (0, uuid_1.v4)(),
                    clientPlatform: platformConfig.clientPlatform,
                    clientType: platformConfig.clientType,
                },
            };
        }
    };
    GamesHttpAdapter.prototype.getResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.getEndpoint()).concat(this.getEndpointPath());
                        return [4 /*yield*/, this.httpLibrary.get(url, {
                                headers: this.getEndpointHeaders(),
                                params: this.getEndpointParams(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    GamesHttpAdapter.prototype.getLoginResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, url, response, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!this.options.platformConfig.password) return [3 /*break*/, 2];
                        url = "".concat(this.getIntegrationEndpoint()).concat(this.getLoginTokenEndpointPath());
                        return [4 /*yield*/, this.httpLibrary.post(url, this.getLoginTokenEndpointParams(), {
                                headers: this.getEndpointHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        this.options.platformConfig.tempToken = response.data;
                        _a.label = 2;
                    case 2:
                        if (!this.options.platformConfig.tempToken) return [3 /*break*/, 4];
                        url = "".concat(this.getEndpoint()).concat(this.getLoginEndpointPath());
                        return [4 /*yield*/, this.httpLibrary.post(url, this.getLoginEndpointParams(), {
                                headers: this.getEndpointHeaders(),
                            })];
                    case 3:
                        response = _a.sent();
                        result = response.data;
                        return [2 /*return*/, {
                                id: result.playerId,
                                username: this.options.platformConfig.playerId,
                                balance: Array.isArray(result.balanceDetails) ? result.balanceDetails.find(function (n) { return n.balanceType === 'cashable'; }).balanceAmt : 0,
                                token: result.secureToken,
                                tokenType: Types_1.TokenType.Bearer,
                            }];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error('[ConfigService] LoginError', error_1);
                        return [2 /*return*/, undefined];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GamesHttpAdapter.prototype.getTranslationsResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var channel, domains, promises, isMultipleDomain, responses, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channel = this.options.applicationName === 'Retail' ? 'shop' : this.options.applicationName;
                        domains = (0, Utility_1.defaultTo)(this.options.translationDomains, [channel === null || channel === void 0 ? void 0 : channel.toLowerCase()]);
                        promises = domains.map(function (domain) { return __awaiter(_this, void 0, void 0, function () {
                            var url, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!domain)
                                            return [2 /*return*/];
                                        url = "".concat(this.getTranslationsEndpoint()).concat(this.getTranslationsEndpointPath(domain));
                                        return [4 /*yield*/, this.httpLibrary.get(url)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.data];
                                }
                            });
                        }); });
                        isMultipleDomain = domains.length > 1;
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _a.sent();
                        if (isMultipleDomain) {
                            result = {};
                            domains.forEach(function (domain, index) {
                                if (!domain)
                                    return;
                                result[domain] = responses[index];
                            });
                        }
                        else {
                            result = responses[0];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    GamesHttpAdapter.prototype.parseResponse = function (data) {
        var configData = data.config;
        var tenantData = data.companyInfo;
        return {
            currency: tenantData.currency,
            currencyDisplay: tenantData.currencySign,
            rules: configData.rules,
            taxes: configData.taxes,
            tenantTimezone: tenantData.timezone,
            taxAuthority: tenantData.taxAuthority,
            translations: data.translations,
            user: data.user,
            bets: configData.bets,
            betLimit: configData.betLimit,
            futureBet: configData.futureBet,
            futureBets: configData.futureBets,
            paymentStrategy: configData.paymentStrategy,
            numberOfContestants: configData.numberOfContestants,
            delayDrawTime: configData.delayDrawTime,
            rawData: data,
        };
    };
    GamesHttpAdapter.prototype.getConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var responsesData, responses, data, responses, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        responsesData = null;
                        if (!this.options.translationsFromFrasier) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                this.getResponse(),
                                this.getTranslationsResponse(),
                                this.getLoginResponse(),
                            ])];
                    case 1:
                        responses = _a.sent();
                        data = responses[0].data;
                        data.translations = responses[1];
                        data.user = responses[2];
                        responsesData = data;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Promise.all([
                            this.getResponse(),
                            this.getLoginResponse(),
                        ])];
                    case 3:
                        responses = _a.sent();
                        data = responses[0].data;
                        data.user = responses[1];
                        responsesData = data;
                        _a.label = 4;
                    case 4: return [2 /*return*/, this.parseResponse(responsesData)];
                }
            });
        });
    };
    return GamesHttpAdapter;
}(HttpAdapter_1.HttpAdapter));
exports.GamesHttpAdapter = GamesHttpAdapter;
//# sourceMappingURL=GamesHttpAdapter.js.map